export const PATIENT_BOOK_APPOINTMENT = "patient_book_appointment";
export const PATIENT_VIEW_APPOINTMENTS = "patient_view_appointments";
export const PATIENT_RESCHEDULE_APPOINTMENT = "patient_reschedule_appointment";
export const PATIENT_CANCEL_APPOINTMENT = "patient_cancel_appointment";
export const PATIENT_VIEW_MEDICAL_RECORD = "patient_view_medical_record";
export const PATIENT_VIEW_MEDICATIONS = "patient_view_medications";
export const PATIENT_FIND_PHARMACY = "patient_find_pharmacy";
export const PATIENT_HEALTH_QA = "patient_health_qa";

export const DOCTOR_CREATE_AVAILABILITY = "doctor_create_availability";
export const DOCTOR_BLOCK_SLOT = "doctor_block_slot";
export const DOCTOR_VIEW_AVAILABILITY = "doctor_view_availability";
export const DOCTOR_VIEW_TODAY_APPOINTMENTS = "doctor_view_today_appointments";
export const DOCTOR_VIEW_PENDING_APPOINTMENTS = "doctor_view_pending_appointments";
export const DOCTOR_SEARCH_PATIENT = "doctor_search_patient";
export const DOCTOR_DIAGNOSTIC = "doctor_diagnostic";
